module.exports = __webpack_public_path__ + "img/shrimp-and-pasta-salad.0ee8b304.jpg";